<script>
export default {
  name: 'Loader',
  props: {
    yes: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'tracefyOrange'
    },
    size: {
      type: Number,
      default: 25
    },
    width: {
      type: Number,
      default: 2
    }
  },
  computed: {
    computedWidth () {
      const size = this.width
      if (!size > 0) {
        const size = this.size / 32
        if (size < 1) {
          return 1
        }
      }

      return size
    }
  }
}
</script>

<template>
    <v-layout style="height: 100%" align-center v-if="yes">
        <v-flex class="text-center">
            <v-progress-circular
                    :size="size"
                    :width="computedWidth"
                    :color="$vuetify.theme.dark ? 'secondary' : color"
                    indeterminate
            ></v-progress-circular>
        </v-flex>
    </v-layout>
</template>
